<div [style.width]="width">
  @if (optionSubtitle) {
    <p-select
      [(ngModel)]="model"
      [options]="orderedOptions"
      [placeholder]="placeholder"
      [optionLabel]="'label'"
      [optionValue]="optionValue"
      [showClear]="showClear"
      [filter]="true"
      [filterFields]="[optionLabel, optionSubtitle]"
      [loading]="loading"
      (ngModelChange)="modelChange.emit(model); onSelectItem()"
      (onClear)="model = null; modelChange.emit(model)"
      appendTo="body"
      styleClass="app-dropdown"
      [emptyFilterMessage]="'No data'"
    >
      <ng-template let-option pTemplate="item">
        <div class="option-main text-wrap">
          @if (optionSubtitleJoiner && option.subtitle) {
            <span>{{ option.label }}{{ optionSubtitleJoiner }}{{ option.subtitle }}</span>
          } @else {
            <div class="option-label">{{ option.label }}</div>
            @if (option.subtitle) {
              <div class="option-subtitle">{{ option.subtitle }}</div>
            }
          }
        </div>
      </ng-template>

      <ng-template pTemplate="selectedItem" let-value>
        <div class="option-main option-main--selected">
          @if (optionSubtitleJoiner && value?.subtitle) {
            <span>{{ value.label }}{{ optionSubtitleJoiner }}{{ value.subtitle }}</span>
          } @else {
            <div class="option-label">{{ value?.label }}</div>
            @if (value?.subtitle) {
              <div class="option-subtitle">{{ value.subtitle }}</div>
            }
          }
        </div>
      </ng-template>
    </p-select>
  } @else {
    <app-dropdown
      [(ngModel)]="model"
      [options]="orderedOptions"
      [optionLabel]="optionLabel"
      [optionValue]="optionValue"
      [placeholder]="placeholder"
      (ngModelChange)="modelChange.emit(model); onSelectItem()"
      [filter]="true"
      [filterPlaceholder]="'Search...'"
      [showClear]="showClear"
      [loading]="loading"
      (onClear)="model = null ; modelChange.emit(model)"
    ></app-dropdown>
  }
</div>
